import React from "react";
import Banner from "../../assets/img/about-us.png";
import CustomBanner from "../../components/CustomBanner";
import { Helmet } from "react-helmet";

const Chatbot = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Whatsapp Chatbot Aydınlatma Metni - LENSA
        </title>
        <meta
          name="description"
          content="Whatsapp Chatbot Aydınlatma Metnini bu sayfayı ziyaret ederek inceleyebilirsiniz."
        />
      </Helmet>
      <CustomBanner
        title="Whatsapp Chatbot Aydınlatma Metni"
        breadTitle="Whatsapp Chatbot Aydınlatma Metni"
        image={Banner}
      />
      <div class="container mx-auto bg-white p-6 shadow-lg rounded-lg">
        <h1 class="text-2xl font-bold mb-4 text-center">
          WhatsApp Chatbot Aydınlatma Metni
        </h1>
        <p class="mb-4">
          Aşağıda yer alan Kişisel Verilerin İşlenmesine İlişkin Aydınlatma
          Metni’ni okuyarak kişisel verilerinizi işleme amaçlarımızı ve bu
          kapsamda haklarınızı ayrıntılarıyla incelemenizi rica ediyoruz.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2">a) Veri Sorumlusu</h2>
        <p class="mb-4">
          6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) uyarınca,
          kişisel verileriniz; veri sorumlusu olarak
          <strong>
            LENSA Sanayi ve Ticaret Anonim Şirketi
          </strong>{" "}
          (“Şirket”) tarafından aşağıda açıklanan kapsamda işlenmektedir.
        </p>

        <h2 class="text-xl font-semibold mt-6 mb-2">
          b) Kişisel Verilerin İşlenme Amaçları, Toplama Yöntemleri ve Hukuki
          Sebepleri
        </h2>

        <div class="mb-4">
          <h3 class="font-semibold">
            İşlemeye Konu Kişisel Veri Kategorileri ve Tipleri
          </h3>
          <ul class="list-disc list-inside">
            <li>
              <strong>Kimlik Bilgisi:</strong> Ad-Soyad
            </li>
            <li>
              <strong>İletişim Bilgisi:</strong> Cep Telefonu, E-Posta Adresi
            </li>
            <li>
              <strong>Diğer- Kullanıcı İşlem Bilgisi:</strong> Talep, Şikayet ve
              Kullanıcı tarafından belirlenecek diğer bilgiler
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h3 class="font-semibold">
            Kişisel Verilerinizin Hangi Amaçlarla İşleneceği
          </h3>
          <p>
            Mal / Hizmet Satış Destek Süreçlerinin Yürütülmesi, Müşteri
            İlişkileri Yönetimi Süreçlerinin Yürütülmesi, Talep / Şikayetlerin
            Takibi.
          </p>
        </div>

        <div class="mb-4">
          <h3 class="font-semibold">
            Kişisel Verilerinizin Hangi Yöntemle Toplandığı ve Hukuki Sebebi
          </h3>
          <p>
            Şirket WhatsApp chatbot konuşmaları üzerinden otomatik olarak
            toplanan kişisel verileriniz KVKK’nın 5. maddesinde belirtilen
            <strong>
              “İlgili kişinin temel hak ve özgürlüklerine zarar vermemek
              kaydıyla, veri sorumlusunun meşru menfaatleri için veri
              işlenmesinin zorunlu olması”
            </strong>
            hukuki sebebine dayanılarak işlenmektedir.
          </p>
        </div>

        <h2 class="text-xl font-semibold mt-6 mb-2">
          c) İşlenen Kişisel Verilerinizin Kimlere ve Hangi Amaçlarla
          Aktarılabileceği
        </h2>

        <p class="mb-4">
          Kişisel verileriniz aşağıda yer verilen üçüncü taraflara ve belirtilen
          amaçlarla aktarılabilecektir:
        </p>

        <div class="mb-4">
          <h3 class="font-semibold">Yurt İçinde Yerleşik Üçüncü Taraf</h3>
          <ul class="list-disc list-inside">
            <li>
              <strong>
                Aktarıma Konu Olabilecek Kişisel Veri Kategorileri ve Tipleri:
              </strong>{" "}
              Yukarıda b bendinde yer alan kişisel verilerin tamamı
            </li>
            <li>
              <strong>Aktarım Amacı:</strong> Mal / Hizmet Satış Destek
              Süreçlerinin Yürütülmesi, Müşteri İlişkileri Yönetimi Süreçlerinin
              Yürütülmesi, Talep / Şikayetlerin Takibi
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h3 class="font-semibold">Yurt Dışında Yerleşik Üçüncü Taraf</h3>
          <ul class="list-disc list-inside">
            <li>
              <strong>
                Aktarıma Konu Olabilecek Kişisel Veri Kategorileri ve Tipleri:
              </strong>{" "}
              Yukarıda b bendinde yer alan kişisel verilerin tamamı
            </li>
            <li>
              <strong>Aktarım Amacı:</strong> Mal / Hizmet Satış Destek
              Süreçlerinin Yürütülmesi, Müşteri İlişkileri Yönetimi Süreçlerinin
              Yürütülmesi, Talep / Şikayetlerin Takibi
            </li>
          </ul>
        </div>

        <h2 class="text-xl font-semibold mt-6 mb-2">
          d) Kişisel Veri Sahibi Olarak KVKK Kapsamındaki Haklarınızla İlgili
          Bilgilendirme
        </h2>

        <p class="mb-4">
          Kişisel veri sahibi olarak, KVKK’nın ilgili kişinin haklarını
          düzenleyen 11. maddesi kapsamındaki haklarınızı
          <em>Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ</em>’e
          göre kullanmak için
          <strong>
            Kaptanpaşa Mahallesi Halit Ziya Türkkan Sokak No: 19/1
            Şişli/İSTANBUL
          </strong>{" "}
          adresine yazılı olarak iletebilir veya{" "}
          <a href="mailto:kvkk@lensa.com.tr" class="text-blue-600 underline">
            kvkk@lensa.com.tr
          </a>{" "}
          e-posta adresine e-posta yoluyla ya da{" "}
          <a
            href="mailto:lensa.bilisim@hs01.kep.tr"
            class="text-blue-600 underline"
          >
            lensa.bilisim@hs01.kep.tr
          </a>{" "}
          KEP adresine iletebilirsiniz.
        </p>
      </div>
    </div>
  );
};

export default Chatbot;
